// @flow

import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-users'

import {
  TREE,
  BRANCH,
} from 'fc-users'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import initialize from './initialize'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize,
})
